import { AdapterType, PaginationRequest, SortingRequest } from '@rp/shared/models';
import { ObjectUtils } from '@rp/utils';

import { PaginationAdapter } from './pagination.adapter';
import { SortingAdapter } from './sorting.adapter';

const toRest = <T>(filter: T, pagination: PaginationRequest, sorting: SortingRequest) => ({
  ...PaginationAdapter.toRest(pagination),
  ...ObjectUtils.stripEmptyFields<Omit<T, 'limit' | 'page'>>(
    {
      ...filter,
      ...SortingAdapter.toRest(sorting),
    },
    true,
  ),
});

export const GenericEntityAdapter = <T>(): AdapterType<T> => ({
  toRest,
});
